import {PrefillFiltersProps, SearchFilters} from "../types/travel.ts";

// Define valid filter keys
export const validFilterKeys = [
    'destination', 'reiseart', 'interesse', 'anreiseart', 'travelType',
    'difficulty', 'price', 'duration', 'yearmonth', 'transport',
    'accommodation', 'locationChanges', 'recommendations', 'unterkunft',
    'rolle', 'veranstalter', 'standortwechsel', 'empfehlung', 'start', 'end'
]

// Function to parse query string into filters
export const parseQueryStringToFilters = (prefillFilters: PrefillFiltersProps, search = window.location.search): SearchFilters => {

    const filters: SearchFilters = {}
    // Define valid filter keys from SearchFilters interface

    // Query-string params always seed the filters when present, regardless of the
    // block's query-string sync setting (that setting only controls writing back to the URL)
    const params = new URLSearchParams(search)

    validFilterKeys.forEach(key => {
        const value = params.get(key)
        if (value) {
            // Handle string fields (start, end) vs array fields
            if (key === 'start' || key === 'end') {
                (filters as any)[key] = value
            } else {
                // Split comma-separated values and filter out empty strings
                const values = value.split(',').map(v => v.trim()).filter(v => v.length > 0)
                if (values.length > 0) {
                    (filters as any)[key] = values
                }
            }
        }
    })

    // Overlay prefill filters on top (prefill takes priority for the same key)
    if(prefillFilters) {
        Object.entries(prefillFilters).forEach(([category, prefillItem]) => {
            if (prefillItem && prefillItem.selected && (prefillItem.selected as string[]).length > 0) {
                if (validFilterKeys.includes(category)) {
                    (filters as any)[category] = prefillItem.selected
                }
            }
        })

        // Map tourencharakter -> difficulty (selected is {value, label} not a string[])
        if (prefillFilters.tourencharakter?.selected) {
            const label = String(prefillFilters.tourencharakter.selected.label)
            if (label) {
                filters.difficulty = [label]
            }
        }
    }

    return filters
}

// Serialize filters into query params (same format parseQueryStringToFilters reads)
export const buildFilterSearchParams = (filters: SearchFilters, gridViewState = true): URLSearchParams => {
    const params = new URLSearchParams()

    Object.entries(filters).forEach(([key, value]) => {
        if (value && validFilterKeys.includes(key)) {
            if (Array.isArray(value) && value.length > 0) {
                params.set(key, value.join(','))
            } else if (typeof value === 'string' && value.trim() !== '') {
                params.set(key, value)
            }
        }
    })

    if (!gridViewState) {
        params.set('termine', 'true')
    }

    return params
}

// Absolute URL of the current page with the given filter state as query string -
// independent of whether the block writes its state to the URL (query-string sync may be off)
export const buildSearchUrl = (
    filters: SearchFilters,
    gridViewState = true,
    pageUrl = window.location.origin + window.location.pathname
): string => {
    const query = buildFilterSearchParams(filters, gridViewState).toString()
    return `${pageUrl}${query ? '?' + query : ''}`
}
